import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function Datenschutz() {
  const { t } = useTranslation();

  return (
    <Layout>
      {/* Page Header */}
      <div className="bg-foreground-900 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider mb-4 block">
            {t('footer.privacy')}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t('datenschutzPage.title')}
          </h1>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="prose prose-lg max-w-none">
            <p className="text-foreground-700 leading-relaxed mb-8">
              Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO), ist:
            </p>
            <p className="text-foreground-700 font-semibold mb-8">
              Maschinenfabrik Bock GmbH & Co. KG
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Ihre Betroffenenrechte
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte ausüben:
            </p>
            <ul className="list-disc list-inside text-foreground-600 leading-relaxed mb-6 space-y-2">
              <li>Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),</li>
              <li>Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),</li>
              <li>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),</li>
              <li>Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),</li>
              <li>Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und</li>
              <li>Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO).</li>
            </ul>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als verantwortliche Stelle zuständige Behörde.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter:{' '}
              <a href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">
                https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
              </a>.
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Erfassung allgemeiner Informationen beim Besuch unserer Website
            </h2>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Art und Zweck der Verarbeitung:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Wenn Sie auf unsere Website zugreifen, d.h., wenn Sie sich nicht registrieren oder anderweitig Informationen übermitteln, werden automatisch Informationen allgemeiner Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem, den Domainnamen Ihres Internet-Service-Providers, Ihre IP-Adresse und ähnliches.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Sie werden insbesondere zu folgenden Zwecken verarbeitet:
            </p>
            <ul className="list-disc list-inside text-foreground-600 leading-relaxed mb-6 space-y-2">
              <li>Sicherstellung eines problemlosen Verbindungsaufbaus der Website,</li>
              <li>Sicherstellung einer reibungslosen Nutzung unserer Website,</li>
              <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
              <li>zur Optimierung unserer Website.</li>
            </ul>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Wir verwenden Ihre Daten nicht, um Rückschlüsse auf Ihre Person zu ziehen. Informationen dieser Art werden von uns ggfs. anonymisiert statistisch ausgewertet, um unseren Internetauftritt und die dahinterstehende Technik zu optimieren.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Rechtsgrundlage und berechtigtes Interesse:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der Verbesserung der Stabilität und Funktionalität unserer Website.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Empfänger:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Empfänger der Daten sind ggf. technische Dienstleister, die für den Betrieb und die Wartung unserer Webseite als Auftragsverarbeiter tätig werden.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Speicherdauer:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Die Daten werden gelöscht, sobald diese für den Zweck der Erhebung nicht mehr erforderlich sind. Dies ist für die Daten, die der Bereitstellung der Website dienen, grundsätzlich der Fall, wenn die jeweilige Sitzung beendet ist.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens 14 Tagen der Fall. Eine darüberhinausgehende Speicherung ist möglich. In diesem Fall werden die IP-Adressen der Nutzer anonymisiert, sodass eine Zuordnung des aufrufenden Clients nicht mehr möglich ist.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Bereitstellung vorgeschrieben oder erforderlich:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder gesetzlich noch vertraglich vorgeschrieben. Ohne die IP-Adresse ist jedoch der Dienst und die Funktionsfähigkeit unserer Website nicht gewährleistet. Zudem können einzelne Dienste und Services nicht verfügbar oder eingeschränkt sein. Aus diesem Grund ist ein Widerspruch ausgeschlossen.
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Verwendung von Google Maps
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Auf dieser Website nutzen wir das Angebot von Google Maps. Google Maps wird von Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (nachfolgend „Google") betrieben. Dadurch können wir Ihnen interaktive Karten direkt in der Webseite anzeigen und ermöglichen Ihnen die komfortable Nutzung der Karten-Funktion.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Nähere Informationen über die Datenverarbeitung durch Google können Sie den Google-Datenschutzhinweisen entnehmen:{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">
                https://policies.google.com/privacy
              </a>. Dort können Sie im Datenschutzcenter auch Ihre persönlichen Datenschutz-Einstellungen verändern.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Ausführliche Anleitungen zur Verwaltung der eigenen Daten im Zusammenhang mit Google-Produkten finden Sie hier:{' '}
              <a href="https://www.dataliberation.org/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">
                https://www.dataliberation.org
              </a>
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Durch den Besuch der Website erhält Google Informationen, dass Sie die entsprechende Unterseite unserer Webseite aufgerufen haben. Dies erfolgt unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie eingeloggt sind, oder ob keine Nutzerkonto besteht. Wenn Sie bei Google eingeloggt sind, werden Ihre Daten direkt Ihrem Konto zugeordnet.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Wenn Sie die Zuordnung in Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung des Buttons bei Google ausloggen. Google speichert Ihre Daten als Nutzungsprofile und nutzt sie für Zwecke der Werbung, Marktforschung und/oder bedarfsgerechter Gestaltung seiner Websites. Eine solche Auswertung erfolgt insbesondere (selbst für nicht eingeloggte Nutzer) zur Erbringung bedarfsgerechter Werbung und um andere Nutzer des sozialen Netzwerks über Ihre Aktivitäten auf unserer Website zu informieren. Ihnen steht ein Widerspruchsrecht zu gegen die Bildung dieser Nutzerprofile, wobei Sie sich zur Ausübung dessen an Google richten müssen.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Widerruf der Einwilligung:
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Vom Anbieter wird derzeit keine Möglichkeit für einen einfachen Opt-out oder ein Blockieren der Datenübertragung angeboten. Wenn Sie eine Nachverfolgung Ihrer Aktivitäten auf unserer Website verhindern wollen, widerrufen Sie bitte im Cookie-Consent-Tool Ihre Einwilligung für die entsprechende Cookie-Kategorie oder alle technisch nicht notwendigen Cookies und Datenübertragungen. In diesem Fall können Sie unsere Website jedoch ggfs. nicht oder nur eingeschränkt nutzen.
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              SSL-Verschlüsselung
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.
            </p>

            <hr className="border-background-200 my-10" />

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO
            </h2>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Einzelfallbezogenes Widerspruchsrecht
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund Art. 6 Abs. 1 lit. f DSGVO (Datenverarbeitung auf der Grundlage einer Interessenabwägung) erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmung gestütztes Profiling im Sinne von Art. 4 Nr. 4 DSGVO.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
            </p>
            <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
              Empfänger eines Widerspruchs
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Maschinenfabrik Bock GmbH & Co. KG
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Änderung unserer Datenschutzbestimmungen
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>

            <h2 className="font-heading text-2xl font-bold text-foreground-900 mt-10 mb-4">
              Fragen an den Datenschutzbeauftragten
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              <a href="mailto:sales@bock-mf.de" className="text-primary-600 hover:text-primary-700 underline">
                sales@bock-mf.de
              </a>
            </p>
            <p className="text-foreground-500 text-sm italic">
              Die Datenschutzerklärung wurde mithilfe der activeMind AG erstellt, den Experten für{' '}
              <a href="https://www.activemind.de/datenschutz/datenschutzbeauftragter/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">
                externe Datenschutzbeauftragte
              </a>{' '}
              (Version #2020-09-30).
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}